<div class="container-fluid px-0 calendar-responsive-page">
    <div class="calendar-status-legend d-flex flex-wrap gap-3 gap-sm-4 align-items-center mb-2">
        <div class="wrapper">
            <div class="square red"></div>Pendientes
        </div>
        <div class="wrapper">
            <div class="square blue"></div>Programados
        </div>
        <div class="wrapper">
            <div class="square orange"></div>Solicitados
        </div>
        <div class="wrapper">
            <div class="square green"></div>Realizados
        </div>
    </div>
    <div class="d-flex flex-column flex-sm-row flex-wrap gap-2 align-items-stretch align-items-sm-center mt-3">
        <p class="text-uppercase font-bold text-1xl bg-white p-2 rounded-2 text-nowrap m-0">Ir a fecha:</p>
        <div class="calendar-filter-control">
            <p-select class="w-100" id="month-dropdown" [options]="months" [(ngModel)]="selectedMonth"
                placeholder="Mes" optionLabel="name" [showClear]="true" (onChange)="showSelectedDate(calendar)"></p-select>
        </div>
        <div class="calendar-filter-control calendar-filter-control-sm">
            <p-select class="w-100" id="year-dropdown" [options]="years" [(ngModel)]="selectedYear"
                placeholder="Año" optionLabel="name" [showClear]="true" (onChange)="showSelectedDate(calendar)"></p-select>
        </div>
        <button *ngIf="env.appName === 'pyf'" class="btn text-nowrap flex-fill flex-sm-grow-0" (click)="downloadCsv()"
            style="background-color: #16A2B7; color: white">
            <i class="fa fa-download"></i>
            Exportar listado
        </button>
        <button class="btn btn-info text-white text-nowrap flex-fill flex-sm-grow-0"  (click)="uploadDialog()">
            <i class="fa fa-upload"></i>
            Importar Análisis
        </button>
    </div>
    <div class="row g-3 mt-2">
        <div class="col-12 col-xl-7 overflow-auto">
            <full-calendar class="fc-responsive-calendar d-block w-100" #calendar [events]="analisisArrayFiltered" [options]="options">
            </full-calendar>
        </div>
        <div class="col-12 col-xl-5 min-w-0">
            <div class="w-100 d-flex justify-content-start justify-content-xl-end mb-2">
                <button *ngIf="this.env.rol !== 'gerencia'" pButton severity="success" type="button"
                    class="w-100 w-sm-auto"
                    (click)="crearAnalisis()">
                    Añadir Recordatorio
                </button>
            </div>
            <p-panel>
                <ng-template #header>
                    <div class="d-flex w-100 justify-content-between align-items-center">
                        <h4 class="title fw-bold m-0">Datos de Análisis</h4>
                        <div class="d-flex flex-wrap justify-content-end align-items-center gap-2 calendar-detail-actions">
                        <button
                            *ngIf="analisisSeleccionado?.id"
                            pButton
                            type="button"
                            icon="fa fa-trash"
                            severity="danger"
                            (click)="showEliminaAnalisis = true"
                            title="Eliminar">
                        </button>
                        <button
                            *ngIf="analisisSeleccionado?.id"
                            pButton
                            type="button"
                            icon="fa fa-pencil"
                            severity="warn"
                            (click)="editAnalisis(analisisSeleccionado)"
                            title="Editar">
                        </button>
                        <button
                            *ngIf="analisisSeleccionado?.id"
                            pButton
                            type="button"
                            icon="fa fa-copy"
                            severity="success"
                            (click)="duplicateAnalisis(analisisSeleccionado)"
                            title="Duplicar">
                        </button>
                        <button
                            pButton
                            type="button"
                            icon="fa fa-refresh"
                            severity="info"
                            (click)="reloadAnalisis()"
                            title="Recargar">
                        </button>
                        </div>
                    </div>
                    </ng-template>
                <div class="calendar-detail-content">
                    <p> <b>Tipo de análisis:</b> {{analisisSeleccionado.tipo_analisis}}</p>
                    <p *ngIf="env.hasClients && env.isAdmin"> <b>{{env.clienteName}}:</b> {{analisisSeleccionado.id_usuario ===
                        1 &&
                        (this.env.applicationType === 'cropgest' && this.env.appName !== 'avafitogest') ? 'Todos' :
                        analisisSeleccionado.cliente_nombre}}</p>
                    <p *ngIf="env.appName === 'avafitogest'"> <b>Laboratorio:</b> {{analisisSeleccionado.laboratorio}}
                    </p>
                    <p *ngIf="env.appName === 'avafitogest'"> 
                        <b>Comunidad de Regantes:</b> {{analisisSeleccionado.comunidad_regantes_nombre}}
                    </p>
                    <p *ngIf="env.hasFincas"><b>{{env.fincaName}}:</b> {{analisisSeleccionado.id_usuario === 1 &&
                        (this.env.applicationType === 'cropgest' && this.env.appName !== 'avafitogest') ? 'Todas' :
                        analisisSeleccionado.finca_nombre}}</p>
                    <p *ngIf="env.showAnalisisParcelas"><b>{{env.parcelasName}}:</b> {{analisisSeleccionado.parcela_nombre}}
                    </p>
                    <p *ngIf="env.appName === 'viverospereira'"><b>{{env.sectoresName}}:</b>
                        {{analisisSeleccionado.sector_nombre}}
                    </p>
                    <p><b>Fecha:</b> {{analisisSeleccionado.fecha}}</p>
                    <p *ngIf="env.appName === 'viverospereira'"><b>Semana:</b> {{analisisSeleccionado.semana}}</p>
                    <p *ngIf="env.appName === 'viverospereira'"><b>Variedad:</b> {{analisisSeleccionado.variedad}}</p>
                    <p *ngIf="env.appName === 'viverospereira'"><b>Formato:</b> {{analisisSeleccionado.formato}}</p>
                    <p *ngIf="env.appName === 'viverospereira'"><b>Remesa:</b> {{analisisSeleccionado.remesa}}</p>
                    <p><b>Muestra:</b> {{analisisSeleccionado.muestra}}</p>
                    <p><b>Frecuencia:</b> {{analisisSeleccionado.frecuencia}}</p>
                    <p *ngIf="env.showAnalisisM3Agua"><b>Agua m<sup>3</sup>:</b> {{analisisSeleccionado.agua_m}}</p>
                    <p *ngIf="env.showAnalisisMgrl || env.showCultivosBajoAguaFields"><b>Nitratos (mg/l):</b>
                        {{analisisSeleccionado.mgrl}}</p>
                    <p *ngIf="env.appName==='ava' || env.appName==='fitogest'"><b>Objeto del análisis:</b>
                        {{analisisSeleccionado.objeto_analisis}}</p>
                    <p *ngIf="analisisSeleccionado?.materia_activa">
                        <span *ngIf="env.appName !== 'laplana'"><b>Notas:</b> </span>
                        <span *ngIf="env.appName === 'laplana'"><b>Notas (cultivo):</b> </span>
                        {{analisisSeleccionado.materia_activa}}
                    </p>
                    <p *ngIf="analisisSeleccionado?.volumen_kg">
                        <b>Volumen (kg):</b> {{analisisSeleccionado.volumen_kg}}
                    </p>
                    <p *ngIf="env.showAnalisisNumeroAnalisis"><b>Referencia Análisis:</b> {{analisisSeleccionado.analisis}}
                    </p>
                    <br>
                    <div *ngIf="env.applicationType === 'viverogest'">
                        <h4>Resultados:</h4>
                        <h6>pH: {{analisisSeleccionado.pH}}</h6>
                        <h6>Conductividad: {{analisisSeleccionado.conductividad}}</h6>
                        <h6>Sulfatos: {{analisisSeleccionado.sulfatos}}</h6>
                        <h6>Nitratos: {{analisisSeleccionado.nitratos}}</h6>
                        <h6>Valoración: {{analisisSeleccionado.valoracion}}</h6>
                    </div>
                    <h6>Estado: {{analisisSeleccionado.estado}}
                        <!-- id="buttons-right" -->
                        <div class="alinear_botones_analisis" style="text-align: left;">
                            <div *ngIf="analisisSeleccionado?.adjunto">
                                <button *ngIf="!navigatorService.isMobile()" type="button" class="btn btn-info"
                                    style="color: white; max-width: 150px;min-width: 150px;"
                                    (click)="verAdjunto(analisisSeleccionado.adjunto ?? '')">
                                    Ver análisis
                                </button>
                                <button *ngIf="navigatorService.isMobile()" type="button" class="btn btn-info"
                                    style="color: white; max-width: 150px;min-width: 150px;"
                                    (click)="descargarAdjunto(analisisSeleccionado.adjunto ?? '')">
                                    <i class="fa fa-download"></i>
                                    Descargar
                                </button>
                            </div>
                            <!-- Adjuntar análisis -->
                            <div *ngIf="analisisSeleccionado?.estado === 'Realizada'" class="adjuntar-analisis-button">
                                <input type="file" #adjuntarAnalisis (change)="fileChange($event)"
                                    style="display: none;" />
                                <button *ngIf="model?.adjunto" class="btn btn-link"
                                    (click)="verAdjunto(analisisSeleccionado.adjunto ?? '')">Ver</button>
                                <input type="button" class="btn btn-sm btn-success" value="Adjuntar análisis"
                                    style="color: white; max-width: 150px; min-width: 150px; padding: 9px 8px; border-radius: 4px;"
                                    (click)="readUrl(adjuntarAnalisis)" />
                            </div>
                            <!-- Cambiar estado -->
                            <button *ngIf="analisisSeleccionado?.id"
                                [disabled]="analisisSeleccionado.estado === 'Realizada'"
                                [style.backgroundColor]="cambiaEstadoColor"
                                style="color: white; max-width: 150px;min-width: 150px;"
                                class="btn btn-sm estado-button" #cambiaEstadoButton
                                (click)="cambiaEstado(cambiaEstadoButton)">
                                {{cambiaEstadoLabel}}
                                <img *ngIf="cambiandoEstado" style="width: 16px; height: 16px;"
                                    src="./assets/icon/load.gif" alt="Cargando" />
                            </button>
                        </div>
                    </h6>
                </div>
            </p-panel>
        </div>
    </div>
</div>

<!-- SUBIR/IMPORTAR ARCHIVO ANÁLISIS -->
<p-dialog header="Importar datos Análisis" [closeOnEscape]="false" [closable]="false" [(visible)]="showModalImport"
    (onShow)="scrollToTop()">

    <div class="container">
        <div>
            <p-fileUpload name="myfile[]" [disabled]="!enableUpload" multiple="false" [showCancelButton]="false"
                chooseLabel="Seleccionar archivo" uploadLabel="Enviar" [url]="urlUpload" (onSelect)="checkFile($event)"
                (onUpload)="uploaded($event)">
            </p-fileUpload>
        </div>

        <div *ngIf="showImportError">
            <br>
            <p style="max-width: 400px; text-align: center; color: red" [innerHTML]="txtImportError"></p>
            <p style="max-width: 400px; text-align: center; color: green" [innerHTML]="txtImportInfo"></p>

        </div>
    </div>

    <ng-template #footer>
        <div class="d-flex justify-content-center">
            <button class="btn btn-dark mx-2" (click)="closeFUDialog();">Cerrar</button>
        </div>
    </ng-template>

</p-dialog>

<p-dialog header="Eliminar Análisis" [(visible)]="showEliminaAnalisis" (onShow)="scrollToTop()">
    <div class="container" style="max-width:480px; width: auto; overflow: auto">
        ¿Seguro que desea eliminar este análisis?
    </div>
    <div class="container" style="text-align:center; max-width:480px; width: auto; overflow: auto">
        <button class="btn btn-secondary" style="margin: 10px;" (click)="showEliminaAnalisis = false;">No</button>
        <button class="btn btn-danger" style="margin: 10px;" (click)="eliminaAnalisis();">Sí</button>
    </div>
</p-dialog>

<p-dialog *ngIf="analisisSeleccionado?.id" header="Fecha y Hora" [(visible)]="showEditAnalisis"
    (onShow)="scrollToTop()">
    <div class="container" style="max-width:480px; width: auto; overflow: auto">
        <p-datePicker #analisisCalendar [(ngModel)]=date [stepMinute]=30 [inline]="true" [showTime]="true">
        </p-datePicker>
    </div>
    <div class="container" style="text-align:center; max-width:480px; width: auto; overflow: auto">
        <button class="btn btn-secondary" style="margin: 10px;" (click)="showEditAnalisis = false;">Volver</button>
    </div>
</p-dialog>

<a id="downloadAdjunto" href="#" download="Adjunto" style="visibility: hidden; position: fixed;"></a>